import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


import { ShActionGroupComponent } from '../action-group/action-group.component';
import { ActionGroup } from '../action-group/entities/action-group.entity';
@Component({
    standalone: true,
    selector: 'sh-action-bar',
    templateUrl: './action-bar.component.html',
    styleUrls: ['./action-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShActionGroupComponent]
})
export class ShActionBarComponent {
    @Input() actionGroup!: ActionGroup;
}
